import BaseAnimationAction from "./baseAnimationAction";

class StopAnimation extends BaseAnimationAction {
    constructor(props) {
        super(props);
    }

    async execute({training}) {
        const branchId = this.getBranchId(training);
        AnimationPlayer.stop(this.meshType, branchId);
    }
}

export default StopAnimation;